export const PASSWORD_MIN_LENGTH_SET = 'common/systemSettings/PASSWORD_MIN_LENGTH_SET'
export const PASSWORD_MIN_LENGTH_ERROR_SET = 'common/systemSettings/PASSWORD_MIN_LENGTH_ERROR_SET'
export const PASSWORD_STRONGER_FLAG_SET = 'common/systemSettings/PASSWORD_STRONGER_FLAG_SET'
export const PASSWORD_REQUIREMENT_SET = 'common/systemSettings/PASSWORD_REQUIREMENT_SET'

export const RESET_STARTED = 'common/systemSettings/RESET_STARTED'
export const RESET_COMPLETED = 'common/systemSettings/RESET_COMPLETED'
export const RESET_FAILED = 'common/systemSettings/RESET_FAILED'

export const RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR = 'common/systemSettings/RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR'

export const CURRENT_PASSWORD_SET = 'common/systemSettings/CURRENT_PASSWORD_SET'
export const NEW_PASSWORD_SET = 'common/systemSettings/NEW_PASSWORD_SET'
export const PASSWORDS_CLEAR = 'common/systemSettings/PASSWORDS_CLEAR'
export const CURRENT_PASSWORD_INVALID_SET = 'common/systemSettings/CURRENT_PASSWORD_INVALID_SET'
export const NEW_PASSWORD_INVALID_SET = 'common/systemSettings/NEW_PASSWORD_INVALID_SET'
export const PASSWORD_VALIDATION_RESULT_SET = 'common/systemSettings/PASSWORD_VALIDATION_RESULT_SET'

export const USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET = 'common/systemSettings/USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET'



// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/actionTypes.js